import { Text } from '@ifood/pomodoro-components';
import styled from 'styled-components';

export const ActionItem = styled(Text)`
  font-family: ${({ theme }): string => theme.font.family.ifood.body};
  font-size: ${({ theme }): string => theme.fontSizes.s};
  line-height: ${({ theme }): string => theme.lineHeights.m};
  text-align: left;
  padding: ${({ theme }): string => theme.space.smaller} ${({ theme }): string => theme.space.large}
    ${({ theme }): string => theme.space.smaller} ${({ theme }): string => theme.space.small};
  cursor: pointer;
  color: ${({ theme }): string => theme.colors.black};
  white-space: nowrap;
`;
